
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
::host{
  display:block;
}

.listing-content {
  display:grid;
  grid-template-columns:repeat(1, minmax(0, 1fr));
  column-gap:2rem;
  row-gap:1rem;
  padding-top:1.5rem;
  padding-bottom:2.5rem;
}

@media (min-width: 768px) {

  .listing-content {
    grid-template-columns:repeat(2, minmax(0, 1fr));
  }

  .listing-content {
    padding-top:3rem;
  }

  .listing-content {
    padding-bottom:3rem;
  }
}

@media (min-width: 1024px) {

  .listing-content {
    grid-template-columns:repeat(3, minmax(0, 1fr));
  }
}

.listing-content a {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

.listing-content a {
  font-weight:var(--fw-medium);
}

.listing-content a {
  color:var(--primary-blue-light-2);
}

.listing-content a {
  text-decoration-line:none;
}

.listing-content a:hover {
  text-decoration-line:underline;
}

:host([site='BH']) .listing-content a {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) .listing-content a {
  font-size:var(--bh-fs-body-02);
  line-height:var(--bh-lh-body-02);
  letter-spacing:var(--bh-ls-body-02);
}

:host([site='BH']) .listing-content a {
  font-weight:var(--fw-bold);
}

:host([site='BH']) .listing-content a {
  color:var(--bh-brand-primary-default);
}
`;